import { TicketAttachmentSource } from "@/pages/Private/pages/Support/pages/TicketDetail/hooks/ticketAttachmentSource";
import {
	useGetStaffTicketAttachmentBlobQuery,
	useLazyGetStaffTicketAttachmentBlobQuery,
} from "@/pages/Private/redux/tickets/tickets-admin.api";

/** The staff page's blob hooks for the shared chip and thumbnail (PREC-3940 decision 10). */
export const STAFF_ATTACHMENT_SOURCE: TicketAttachmentSource = {
	useBlobQuery: useGetStaffTicketAttachmentBlobQuery,
	useLazyBlobQuery: useLazyGetStaffTicketAttachmentBlobQuery,
};
